import React from "react";
import loanLibraryIcon from "../../../../images/Loan_Library.svg";

interface CatalogItemImageProps {
    imageUrl?: string | null;
    productName?: string;
}

export const CatalogItemImage: React.FC<CatalogItemImageProps> = ({
    imageUrl,
    productName,
}) => {
    if (imageUrl) {
        return (
            <div className="catalog-item__image">
                <img src={imageUrl} alt={productName || "Catalog item"} />
            </div>
        );
    }

    return (
        <div className="catalog-item__image catalog-item__image--placeholder">
            <img
                src={loanLibraryIcon}
                alt="RMTC Loan Library"
                className="catalog-item__image-logo"
            />
        </div>
    );
};
